import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import t from '../../../../lib/I18n';
import FormattedHTMLMessage from '../../../general/FormattedHTMLMessage';

const Success = () => {
    return (
        <Grid>
            <Row className="auto-dr__payment-wrapper flex-column margin-top--md margin-bottom--sm">
                <Col xs="12"><img className="auto-dr__success-screen-icon" src="/images/blue-tick-circle.svg" alt="Tick icon in a circle" /></Col>
                <Col xs="12">
                    <h2 className="auto-dr__header auto-dr-header--subscribe-success">{t('one-click-delay-repay.optIn.success.header')}</h2>
                    <FormattedHTMLMessage message="one-click-delay-repay.optIn.success.copy" splitParagraphs />
                </Col>
            </Row>
        </Grid>
    );
};

export default Success;
